<template>
  <div class="chart" style="width: 100%; height: 96%">
    <div ref="barChart" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "barChartView",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "650px",
    },
    barWidth: {
      type: String,
      default: "14px",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "canvas",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.setOptions();
      },
    },
  },
  mounted() {
    this.initChart();
    if (this.autoResize) {
      window.addEventListener("resize", this.resizeHandler);
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.resizeHandler);
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeHandler() {
      this.chart.resize();
    },
    initChart() {
      this.chart = echarts.init(this.$refs.barChart, "", {
        renderer: this.type,
      });
      this.initChartOption();
      this.chart.on("click", this.handleClick);
    },
    initChartOption() {
      const _this = this;
      let length = _this.data.length;
      let maxNum = null;
      // eslint-disable-next-line no-unused-vars
      let minNum = null;
      // todo 后期建议优化
      switch (true) {
        case length >= 100 && length <= 200:
          maxNum = length / 100 + 9;
          break;
        case length >= 200 && length <= 300:
          maxNum = length / 100 + 5;
          break;
        case length >= 300 && length <= 400:
          maxNum = length / 100 + 2;
          break;
        case length >= 400 && length <= 500:
          maxNum = length / 100;
          break;
        default:
          maxNum = 1;
          break;
      }
      switch (true){
        case (length >= 20 && length <= 30):
          minNum = 100 - length
          break
        case (length >= 30 && length <= 50):
          minNum = (100 - length) - 10
          break
        case (length >= 50 && length <= 70):
          minNum = (100 - length) - 5
          break
        case (length >= 70 && length <= 90):
          minNum = (100 - length)
          break
        default:
          minNum = length - 80;
          break;
      }

      // let colorList = ['#468FF7', '#00FED2', '#FFD37A', '#468FF7', '#00FED2', '#FFD37A']

      let echart = {
        dataZoom:
          _this.data.length >= 20
            ? [
                {
                  type: "slider",
                  show: false,
                  // 设置组件控制的y轴
                  yAxisIndex: 0,
                  // left: 300,
                  // top: 60,
                  // 数据窗口范围的起始百分比。范围是：0 ~ 100。表示 0% ~ 100%
                  // 也可以用 startValue设置起始值
                  start: 0,
                  // 100 / 2 = 50  200 / 2 = 100  300 / 2 = 150  400 / 2 = 200
                  // 200 / 100 =
                  end: length >= 100 ? maxNum : minNum,
                  width: 10,
                  // height: 450,
                  // 组件的背景颜色
                  // left: 600, //左边的距离
                  // right: 8,//右边的距离
                  borderRadius: 10,
                  borderColor: "#0C2C60",
                  fillerColor: "#97A7C2", //滑动块的颜色
                  backgroundColor: "rgba(12,44,96,0.68)", //两边未选中的滑动条区域的颜色
                  // 是否显示detail，即拖拽时候显示详细数值信息
                  showDetail: false,
                  // 控制手柄的尺寸
                  handleSize: 15,
                  // 是否在 dataZoom-silder 组件中显示数据阴影。数据阴影可以简单地反应数据走势。
                  showDataShadow: false,
                },
                {
                  type: "inside",
                  yAxisIndex: [0],
                  start: 1,
                  // end: 36,
                  // 不按任何功能键，鼠标滚轮能触发缩放
                  zoomOnMouseWheel: false,
                  // 不按任何功能键，鼠标移动能触发数据窗口平移
                  moveOnMouseWheel: true,
                },
              ]
            : [],
        // color: colorList,
        backgroundColor: "transparent",
        tooltip: {
          show: true,
          trigger: "item",
          padding: [8, 15],
          backgroundColor: "rgba(12, 51, 115,0.8)",
          borderColor: "rgba(3, 11, 44, 0.5)",
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
          },
        },
        legend: {
          show: false,
        },
        // 设置坐标轴y的刻度值宽度
        grid: {
          left: "25%",
          right: "15%",
          top: "1%",
          bottom: "1%",
        },
        // x轴的参数设置
        xAxis: [
          {
            splitLine: {
              show: false,
            },
            type: "value",
            show: false,
          },
        ],
        // y轴的参数设置
        yAxis: [
          {
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            type: "category",
            axisTick: {
              show: false,
            },
            inverse: true,
            // max: 20,
            // min: 0,
            // splitNumber: 4,
            data: _this.data.map((item) => item.farmName),
            axisLabel: {
              color: "#b5dbff",
              fontSize: 14,
              // margin: 10,
              width: 180,
              overflow: "truncate",
              ellipsis: "...",
            },
          },
          // 关闭右侧展示
          // {
          //   type: "category",
          //   inverse: true,
          //   axisTick: "none",
          //   axisLine: "none",
          //   show: true,
          //   axisLabel: {
          //     textStyle: {
          //       color: "#b5dbff",
          //       fontSize: 14,
          //     },
          //     width: 100,
          //     overflow: "truncate",
          //     ellipsis: "...",
          //   },
          //   data: _this.data.map((item) => item.count),
          // },
        ],
        // 数据展示样式和内容
        series: [
          {
            name: "各村畜禽排行",
            type: "bar",
            barWidth: 22, // 柱子宽度
            MaxSize: 0,
            showBackground: false,
            // backgroundStyle: {
            //   // color: "#0f3c63",
            //   color: "#ffffff",
            // },
            label: {
              show: false,
            },
            itemStyle: {
              normal: {
                // 柱状图，渐变色
                color: function (params) {
                  var colorList = [
                    {
                      colorStops: [
                        {
                          offset: 0,
                          color: "#f0515e",
                        },
                        {
                          offset: 1,
                          color: "#ef8554",
                        },
                      ],
                    },
                    {
                      colorStops: [
                        {
                          offset: 0,
                          color: "#3c38e4",
                        },
                        {
                          offset: 1,
                          color: "#24a5cd",
                        },
                      ],
                    },
                  ];
                  if (params.dataIndex < 3) {
                    return colorList[0];
                  } else {
                    return colorList[1];
                  }
                },
                label: {
                  show: true,
                  position: "right",
                  offset: [8, 0],
                  textStyle: {
                    //数值样式，显示的文字大小和颜色
                    fontSize: "12",
                    color: "rgba(255,255,255,0.55)",
                    fontWeight: 600,
                    lineHeight: "18",
                  },
                },
              },
              // 柱状图hover颜色
              emphasis: {
                color: "#3c38e4",
              },
            },
            data: _this.data.map((item) => {
              return {
                name: item.farmName,
                value: item.count,
                // itemStyle: {
                //   color: "#0556ba",
                // },
              };
            }),
          },
          /*{
            // name: '柱状图',
            // type: 'bar',
            roam: false,
            visualMap: false,
            barWidth: 24,
            zlevel: 2,
            barGap: 0,

            name: "各村畜禽排行",
            type: "bar",
            // barWidth: 24, // 柱子宽度
            // MaxSize: 0,
            // showBackground: true,
            // backgroundStyle: {
              // color: "#0f3c63",
              // color: "#ffffff",
            // },

            itemStyle: {
              normal: {
                // 柱状图，渐变色
                color: function (params) {
                  var colorList = [{
                    colorStops: [{
                      offset: 0,
                      color: '#f0515e'
                    }, {
                      offset: 1,
                      color: '#ef8554'
                    }]
                  },
                    {
                      colorStops: [{
                        offset: 0,
                        color: '#3c38e4'
                      }, {
                        offset: 1,
                        color: '#24a5cd'
                      }]
                    }
                  ];
                  if (params.dataIndex < 3) {
                    return colorList[0]
                  } else {
                    return colorList[1]
                  }
                },
                label: {
                  show: true,
                  position: 'insideLeft',
                  offset: [425, -10],
                  textStyle: {
                    //数值样式，显示的文字大小和颜色
                    fontSize: '12',
                    color: 'rgba(255,255,255,0.55)',
                    fontWeight: 600,
                    lineHeight: '18',
                  },
                },
              },
              // 柱状图hover颜色
              emphasis: {
                color: "#3c38e4"
              },
            },
            // label: {
            //   normal: {
            //     show: true,
            //     position: 'right',
            //     textBorderWidth: 0
            //   }
            // },
            data: _this.data.map((item) => item.count)
          }*/
        ],
      };
      // {
      //   data: [],
      //       color: '#08B76F',
      //     type: 'bar',
      //     barWidth: '12px',
      //     showBackground: true,
      //     backgroundStyle: {
      //   color: '#E9EDF2',
      //       borderRadius: 15,
      // },
      //   itemStyle: {
      //     normal: {
      //       label: {
      //         show: true,
      //             position: 'insideLeft',
      //             offset: [284, 0],
      //             textStyle: {
      //           //数值样式，显示的文字大小和颜色
      //           fontSize: '12',
      //               color: 'rgba(0,0,0,0.55)',
      //               fontWeight: 400,
      //               lineHeight: '18',
      //         },
      //         formatter: formatterFun,
      //       },
      //       barBorderRadius: 15,
      //     },
      //   },
      // },

      /*function _sort(array) {
        if (array instanceof Array) {
          return array.sort((left, right) => right - left)
        }
      }*/

      /*var salvProName = _this.data.map((item) => item.farmName)
      var salvProValue = _this.data.map((item) => item.count)
      var salvProMax =[];//背景按最大值
      for (let i = 0; i < salvProValue.length; i++) {
        salvProMax.push(salvProValue[0])
      }*/

      /*let echart = {
        grid: {
          left: '10%',
          right: '10%',
          bottom: '5%',
          top: '6%',
          containLabel: true
        },
        dataZoom: [
          // {
          //   id: 'dataZoomX',
          //   type: 'slider',
          //   xAxisIndex: [0],
          //   filterMode: 'filter', // 设定为 'filter' 从而 X 的窗口变化会影响 Y 的范围。
          //   start: 30,
          //   end: 70
          // },
          {
            id: 'dataZoomY',
            type: 'slider',
            yAxisIndex: [0],
            filterMode: 'empty',
            start: 20,
            end: 80,
              zoomOnMouseWheel: false,  // 关闭滚轮缩放
              moveOnMouseWheel: true, // 开启滚轮平移
              moveOnMouseMove: true  // 鼠标移动能触发数据窗口平移
          }

          // {
          //   id: 'dataZoomY',
          //
          //
          //   // // 第一个 dataZoom 组件
          //   // type: "inside",
          //   // yAxisIndex: 0, // 表示这个 dataZoom 组件控制 第一个 xAxis
          //   // startValue: 0, // 数据窗口范围的起始数值index
          //   // endValue: 5, // 数据窗口范围的结束数值index
          //
          //   // type: 'inside',     // inside: 表示用内测滑块
          //   // startValue: 0,     // 开始显示的数
          //   // endValue: 5,       // 结束显示的数
          //   // yAxisIndex: [0],    // 代表是作用在y轴上的
          //   // start: 0,
          //   // end: 5,
          //   // zoomLock: true,
          //   // zoomOnMouseWheel: false,  // 关闭滚轮缩放
          //   // moveOnMouseWheel: true, // 开启滚轮平移
          //   // moveOnMouseMove: true  // 鼠标移动能触发数据窗口平移
          //
          //   // id: 'dataZoomY',
          //   // type: 'inside',
          //   // yAxisIndex: [0],
          //   // // filterMode: 'empty',
          //   // // height: 120,
          //   // width:4,
          //   // start: 1, end: 50
          // }
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function(params) {
            return params[0].name  + ' : ' + params[0].value
          }
        },
        xAxis: {
          show: false,
          type: 'value'
        },
        yAxis: [{
          // type : 'category',
          // scale : true,
          // max : 500,
          // min : 0,
          // splitNumber : 1,
          // boundaryGap : [ 0.2, 0.2 ],

          type: 'category',
          inverse: true,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff'
            },
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: salvProName
        }, {
          type: 'category',
          inverse: true,
          axisTick: 'none',
          axisLine: 'none',
          show: true,
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: '12'
            },
          },
          data:salvProValue
        }],
        series: [{
          name: '值',
          type: 'bar',
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 30,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                offset: 0,
                color: 'rgb(57,89,255,1)'
              }, {
                offset: 1,
                color: 'rgb(46,200,207,1)'
              }]),
            },
          },
          barWidth: 20,
          data: salvProValue
        },
          {
            name: '背景',
            type: 'bar',
            barWidth: 20,
            barGap: '-100%',
            data: salvProMax,
            itemStyle: {
              normal: {
                color: 'rgba(24,31,68,1)',
                barBorderRadius: 30,
              }
            },
          },
        ]
      }*/

      this.chart.setOption(echart);

      // setInterval(() => {
      //   console.log('this.chart', )
      //   console.log('this.chart', _this.chart)
      //   echart.dataZoom[0].endValue = echart.dataZoom[0].endValue + 1;
      //   echart.dataZoom[0].startValue = echart.dataZoom[0].startValue + 1;
      //   _this.chart.setOption(echart)
      //   // console.log(TopActOpt.dataZoom[0].endValue)
      //   // console.log(TopActOpt.dataZoom[0].startValue)
      // }, 3000);
    },
    handleClick(params) {
      this.$emit("click", params);
    },
    setOptions() {
      this.clearChart();
      this.resizeHandler();
      if (this.chart) {
        this.initChartOption();
      }
    },
    refresh() {
      this.initChartOption();
    },
    clearChart() {
      this.chart && this.chart.clear();
    },
  },
};
</script>
